module.exports = __webpack_public_path__ + "img/MH.1ce06f01.svg";